var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:([_vm.headerBg ? {backgroundImage: _vm.headerBg} : {backgroundImage: 'radial-gradient(circle farthest-corner at 13% 102%, #3b464e 21%, #080806)'}]),attrs:{"id":"header"}},[_c('h1',[_vm._v(_vm._s(_vm.headerTitle))])])}
var staticRenderFns = []

export { render, staticRenderFns }